'use strict';

var React = require('react'),
    StampImageMixin = require('../mixins/StampImageMixin'),
    Img = require('../atoms/Image'),
    ImageCaption = require('./ImageCaption'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    SectionTypes = require('../constants/SectionTypes'),
    gradient = require('../utils/gradient');

require('./legacy/Stamp.less');
require('./Poster.less');

var Poster = React.createClass({
  mixins: [StampImageMixin, PureRenderMixin],

  propTypes: {
    stamp: React.PropTypes.object.isRequired,
    background: React.PropTypes.object.isRequired,
    sectionIndex: React.PropTypes.number.isRequired,
    isActive: React.PropTypes.bool.isRequired,
    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
    toggleLightbox: React.PropTypes.func.isRequired,
    getLightboxImageStyle: React.PropTypes.func.isRequired,
    onImageTransitionEnd: React.PropTypes.func.isRequired
  },

  getImageSizes: function () {
    return {
      'default': 480,
      'xs': 640,
      'sm': 992,
      'md': 1200,
      'lg': 1440,
      'xl': 1600
    };
  },

  getImage(props) {
    return props.background;
  },

  render: function () {
    var background = this.props.background,
        caption = background.caption,
        colors = background.colors,
        { isActive, lightboxState } = this.props,
        imageStyle = this.props.getLightboxImageStyle(background),
        style = {};

    if (lightboxState || !this.hasLoadedImage()) {
      style.backgroundImage = gradient('#' + colors.top, '#' + colors.bottom);
    }

    return (
      <div className='stamp-Poster'
           data-active={isActive}
           data-lightbox={lightboxState}
           data-scroll-anchor
           style={style}
           onClick={this.toggleAttributionOnMobile}>

        <div className='stamp-Poster-imageWrapper'>
          <Img className='stamp-Poster-img'
               src={this.getImageSrcUrl()}
               style={imageStyle}
               onClick={this.handleImageClick}
               onTransitionEnd={this.props.onImageTransitionEnd}
               onLoad={this.handleImageLoad}
               onError={this.handleImageError} />
          {this.renderUsageCounter()}
          {this.renderAttributionOnMobile()}
        </div>

        {caption.length > 0 &&
          <ImageCaption caption={caption}
                        context='Poster' />
        }
      </div>
    );
  },

  handleImageClick: function (e) {
    var boundingRect = e.target.getBoundingClientRect(),
        image = this.props.background;

    this.props.toggleLightbox(
      this.props.sectionIndex,
      SectionTypes.POSTER,
      image,
      boundingRect
    );
  }
});

module.exports = Poster;



/** WEBPACK FOOTER **
 ** ./stamp/Poster.jsx
 **/